export default __webpack_public_path__ + "39bf1a6db489374c389aa677c00cf0e4.png";